import { render, staticRenderFns } from "./HorseGenders.vue?vue&type=template&id=0d780376"
import script from "./HorseGenders.vue?vue&type=script&lang=js"
export * from "./HorseGenders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports